<div class="text-skeleton-container">
  <ion-skeleton-text
    *ngIf="showTitle"
    animated
    class="skeleton-title"
  ></ion-skeleton-text>

  <ion-skeleton-text
    *ngFor="let line of linesArray"
    animated
    class="skeleton-line"
  ></ion-skeleton-text>
</div>